import { advancementTypes } from '@modules/shared/constants';

import { tagTypes } from '../constants';

export type AdvancementDetailsArgs = {
  advancementId: string;
};

export const getAdvancementDetailsQuery = (
  advancementType: advancementTypes,
) => ({
  query: (arg: AdvancementDetailsArgs) => {
    const useV2 = advancementType !== advancementTypes.AWARDS;
    const url = useV2
      ? `/advancements/v2/${advancementType}/${arg.advancementId}`
      : `/advancements/${advancementType}/${arg.advancementId}`;
    return {
      url,
      method: 'GET',
    };
  },
  providesTags: (
    _result: unknown,
    error: unknown,
    arg: AdvancementDetailsArgs,
  ) =>
    error
      ? []
      : [
          {
            type: tagTypes.AdvancementDetails,
            id: `${advancementType}-${arg.advancementId}`,
          },
        ],
});

export type GeneralAdvancementDetailsArgs = {
  advancementType: advancementTypes;
  advancementId: string;
};

export const getGeneralAdvancementDetailsQuery = () => ({
  query: (arg: GeneralAdvancementDetailsArgs) => {
    const useV2 = arg.advancementType !== advancementTypes.AWARDS;
    const url = useV2
      ? `/advancements/v2/${arg.advancementType}/${arg.advancementId}`
      : `/advancements/${arg.advancementType}/${arg.advancementId}`;
    return {
      url,
      method: 'GET',
    };
  },
  providesTags: (
    _result: unknown,
    error: unknown,
    arg: GeneralAdvancementDetailsArgs,
  ) =>
    error
      ? []
      : [
          {
            type: tagTypes.AdvancementDetails,
            id: `${arg.advancementType}-${arg.advancementId}`,
          },
        ],
});
